export default {
  title: 'One par Nextories',
  pageTitle: '{page} · Nextories One',
  brand: 'One',
  brandFull: 'Nextories One',
  nav: {
    label: 'Pilotage',
    overview: 'Vue d’ensemble',
    leads: 'Leads',
    leadsHelper: 'Règles par zone',
    premium: 'Premium',
    premiumHelper: 'Rendez-vous et visites',
    online: 'Online',
    onlineHelper: 'Parcours autonome',
  },
  search: {
    placeholder: 'Rechercher une région ou un département',
    label: 'Rechercher une région ou un département',
  },
  userMenu: {
    open: 'Ouvrir le menu utilisateur',
    account: 'Mon compte',
    password: 'Mot de passe',
    roles: 'Gestion des rôles',
    logout: 'Déconnexion',
  },
  roles: {
    admin: 'Admin',
    user: 'User',
  },
  demo: {
    badge: 'Données de démonstration',
    tooltip: 'Cet écran n’est pas encore connecté à l’API One : les valeurs et les enregistrements sont simulés dans le navigateur.',
  },
  actions: {
    cancel: 'Annuler',
    close: 'Fermer',
    save: 'Enregistrer',
    back: 'Retour',
    retry: 'Réessayer',
  },
  errors: {
    network: 'Le serveur One ne répond pas. Vérifiez votre connexion et réessayez.',
    generic: 'Une erreur est survenue. Réessayez dans un instant.',
    forbidden: 'Vous n’avez pas les droits pour cette action.',
    throttled: 'Trop de tentatives. Réessayez dans une minute.',
    sessionLost: 'Votre session a expiré. Reconnectez-vous pour continuer.',
  },
};
